import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70a2c3af&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2c3af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a2c3af')) {
      api.createRecord('70a2c3af', component.options)
    } else {
      api.reload('70a2c3af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70a2c3af&scoped=true", function () {
      api.rerender('70a2c3af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/smsConfiguration/index.vue"
export default component.exports